import React, { useEffect, useState } from 'react';
import {
	dbDateToTimestamp,
	parseEntities,
	toLongDateDisplay,
	parseDateDesktopShort,
} from '../../utils/helpers';
import Tag from './Tag';
import AgendaIcon from '../svg/AgendaIcon';
import HoverAgendaIcon from '../svg/HoverAgendaIcon';

const Card = ({
	element,
	setTagsParam,
	}) => {

	const [releaseDate, setReleaseDate] = useState('');

	useEffect(() => {
		if ('date_range' in element && element.date_range[0]) {
			const date = dbDateToTimestamp(element.date_range[0] + '0000');
			setReleaseDate(date);
		}
	});

	useEffect(() => {
		if ('dates' in element && element.dates.release) {
			const date = dbDateToTimestamp(element.dates.release + '0000');
			setReleaseDate(date);
		}
	}, []);

	const handleTagClick = (value, onlyActivate) => {
		setTagsParam(value, onlyActivate);
	}

	return (
		<a className={ "tile " + element.color } href={element.permalink}>
			<div className="tile__img-date">
				<div className="tile__img-container">
					<img
						src={element.poster_mobile ? element.poster_mobile : element.poster_desktop}
						alt=""
						className="tile__img"
					/>
				</div>
					{releaseDate &&
						<time dateTime={toLongDateDisplay(parseDateDesktopShort(releaseDate))} className="tile__date subtitle">
							<div className="tile__date-content">
								<p className="tile__day subtitle"> {(toLongDateDisplay(parseDateDesktopShort(releaseDate)) === "vandaag" || toLongDateDisplay(parseDateDesktopShort(releaseDate)) === "morgen") ? toLongDateDisplay(parseDateDesktopShort(releaseDate)) : toLongDateDisplay(parseDateDesktopShort(releaseDate))[0]}</p>
								<span className="">{(toLongDateDisplay(parseDateDesktopShort(releaseDate)) === "vandaag" || toLongDateDisplay(parseDateDesktopShort(releaseDate)) === "morgen") ? "" : toLongDateDisplay(parseDateDesktopShort(releaseDate))[1]}</span>
							</div>
						</time>
					}
				</div>
			<div className="tile__details">
				<div class="tile__text">
					<h3 className="tile__title">
						{parseEntities(element.title)}
					</h3>
					<p className="subtitle tile__subtitle">{parseEntities(element.subtitle)}</p>
					<div className="tile__time-location subtitle">{`${element.times[0].program_start.substring(8, 10)}:${element.times[0].program_start.substring(10, 12)} uur - `}
						<span class="location">{Object.values(element.times[0].location)[0]}</span>
					</div>
					<div className="">
						{element.tags?.categories && Object.keys(element.tags.interests).map((category, index) => (
							<Tag  key={index} tagText={element.tags.interests[category]} displayIcon={false}/>
						))}
					</div>
				</div>
				{
					element.times[0].available && element.times[0].ticket_link ?
					( element.times[0].status_label &&
					<a
						href={element.times[0].ticket_link}
						className="tile__button"
					>
						  <div className="icons-wrapper">
								<div className="icon-wrapper1"><AgendaIcon /></div>
								<div className="icon-wrapper2"> <HoverAgendaIcon /></div>
						  </div>
						<h4 className="tile__button-h4">
							{element.times[0].status_label}
						</h4>
					</a> )
					:
					element.times[0].status_label &&
						<button className="tile__button tile__button--inactive">
							<h4 className="tile__button-h4">
								{element.times[0].status_label}
							</h4>
						</button>
				}
			</div>
		</a>
	)
}

export default Card;
